export const CREATOR_OVERVIEW_MULTI_BRAND = [
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 0, meta: { name: 'UGC Performance - Instagram' } },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 1,
    meta: { brand_ids: ['brand_ids'], channels: ['INSTAGRAM_UGC'], metrics: ['UGC_EMV'] },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ESTIMATED_REACH'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 5,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 5,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_COMMENTS'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 9,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_AVG_ENGAGEMENT_RATE_FOLLOWERS'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 9,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 13,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ESTIMATED_REACH'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_UGC',
    w: 6,
    x: 0,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ENGAGEMENT_RATE'],
      sort_order: 'DESC',
    },
  },
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 46, meta: { name: 'UGC Performance - TikTok' } },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 47,
    meta: { brand_ids: ['brand_ids'], channels: ['TIKTOK_UGC'], metrics: ['UGC_EMV'] },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 47,
    meta: { brand_ids: ['brand_ids'], channels: ['TIKTOK_UGC'], metrics: ['VIDEO_VIEWS'] },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 51,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 51,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['COMMENTS'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 55,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['SHARES'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 55,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 59,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['VIDEO_VIEWS'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_UGC',
    w: 6,
    x: 0,
    y: 63,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CONTENT_UGC',
    w: 6,
    x: 0,
    y: 67,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_REACH'],
      sort_order: 'DESC',
    },
  },
];
